import { render } from "./DataTableComponentTrans.vue?vue&type=template&id=7f4a22de"
import script from "./DataTableComponentTrans.vue?vue&type=script&lang=js"
export * from "./DataTableComponentTrans.vue?vue&type=script&lang=js"

import "./DataTableComponentTrans.vue?vue&type=style&index=0&id=7f4a22de&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__